import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { IllustrationHost as Illustration } from '../illustration/illustrationHost';
const ElementOrIllustrationComponent = (props, ref) => {
    const { illustration: element, ...rest } = props;
    if (!element) {
        return _jsx(_Fragment, {});
    }
    // element as string
    if (typeof element === 'string') {
        return _jsx(Illustration, { ...rest, ref: ref, illustration: element });
    }
    // element as jsx element
    return _jsx(_Fragment, { children: element });
};
/**
 * @deprecated
 * This component is deprecated and will be removed in future versions.
 */
export const ElementOrIllustration = React.forwardRef(ElementOrIllustrationComponent);
//# sourceMappingURL=elementOrIllustration.js.map